import { PLANT_API_BASE_URL } from 'shared/constants/constants';

export const PlantItemConstants = {
  licenceType: 'PIRA',
  licenceTypeDescription: 'Plant Item Registration - New/Reapply',
  transactionType: 'New',
  snswLandingPageUrl: 'https://www.service.nsw.gov.au/transaction/apply-to-register-an-item-of-plant',
};

export const PlantItemNewOngoingContactTypes = {
  me: { label: 'I will be', value: 'me' },
  registrationHolder: { label: 'Registration holder', value: 'registrationHolder' },
  someoneElse: { label: 'Someone else', value: 'someoneElse' },
};

export const PLANT_ITEM_NEW_API_BASE_URL = `${PLANT_API_BASE_URL}/item/new`;
